import Vue from 'vue'
import Vuex from 'vuex'
import catalogs from './modules/catalogs'
import common from './modules/common'
import user from './modules/user'
import assets from './modules/assets'
import dialog from './modules/dialog'
import tableView from './modules/tableView'
import simpleTable from './modules/simpleTable'
import dataIterator from './modules/dataIterator'
import charts from './modules/charts'
import actionDialog from './modules/action-dialog'
import quickEmployee from './modules/quickEmployee'
import calendar from './modules/calendar'

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		catalogs,
		common,
		user,
		assets,
		dialog,
		tableView,
		simpleTable,
		dataIterator,
		charts,
		actionDialog,
		quickEmployee,
		calendar
	}
})